export default __webpack_public_path__ + "static/media/FortisHeader3.873114c5.png";